import { MdSend } from 'react-icons/md';
import { useState, useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import { addMessage } from '../Messages/messageSlice';
import { Select } from 'antd';
import { scoutChatCenterServerUrl } from '../../../../autoConfig';
const { Option } = Select;
const Textarea = styled.textarea`
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const sendMessage = async ({ url, payload }) => {
  try {
    const response = await axios({
      method: 'post',
      url,
      data: payload,
      headers: {
        WebChatApplicationId: '78a7438e-2f83-43e7-8927-8f89e1582761'
      }
    });
    return response;
  } catch (error) {
    console.log('error occurred fetching bot response', error);
    return [];
  }
};

export const Keypad = memo(() => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [userInput, setUserInput] = useState('');
  const [role, setRole] = useState('');
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [teams, setTeams] = useState([]);
  const [typing, setTyping] = useState(false);
  const userTypingPlaceholder = useSelector(
    (state) => state.messageState.userTypingPlaceholder
  );

  const defaultSentences = [
    'Is there anything else I can help you with?',
    'You are welcome!! Have a great day!',
    'Thank you.',
    'Do you need a hotel/car reservation?',
    'Airfares are not guaranteed until ticketed.',
    'Would you like me to make this change for you?',
    'Would you like me to issue a ticket for this reservation?',
    'You will receive the invoice/itinerary shortly.',
    'This air fare is nonrefundable, and any changes may result in a higher fare.'
  ];

  const handleSubmit = async () => {
    if (userInput.trim()) {
      dispatch(
        addMessage({
          text: userInput.trim(),
          sender: 'USER',
          chatId: id,
          type: 'text',
          ts: new Date()
        })
      );
      setUserInput('');
      sendMessage({
        url: `${scoutChatCenterServerUrl}/chat/messageFromConsultants/${id}`,
        payload: { message: userInput.trim() }
      });
      setTyping(false);
      sendMessage({
        url: `${scoutChatCenterServerUrl}/chat/messageFromConsultants/${id}`,
        payload: { typing: false }
      });
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setUserInput(value);

    if (value.trim()) {
      setTyping(true);
    } else {
      setTyping(false);
    }
  };

  useEffect(() => {
    sendMessage({
      url: `${scoutChatCenterServerUrl}/chat/messageFromConsultants/${id}`,
      payload: { typing: typing }
    });
  }, [typing]);

  useEffect(() => {
    const name = JSON.parse(localStorage.getItem('username'))[0].value;
    setRole(sessionStorage.getItem('role'));
    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'get',
          url: `${scoutChatCenterServerUrl}/consultant/getConsultant/${name}`
        });
        setTeams(response.data.consultant.teams);
      } catch (error) {
        console.log('error occurred fetching chat history', error);
        return [];
      }
    };

    fetchData();
  }, []);

  const handleTeamSelect = (value) => {
    const selected = teams.find((team) => team.teamName === value);
    if (selected) {
      const mergedSentences = [
        ...defaultSentences,
        ...selected.frequentSentences
      ];
      setSelectedTeam({
        ...selected,
        frequentSentences: mergedSentences
      });
    }
  };

  return (
    <div className="mt-auto bg-slate-300 rounded-b-[16px] ">
      <div className="mt-4 ml-4">
        <Select
          style={{ width: '30%', marginRight: 12 }}
          onSelect={handleTeamSelect}
          placeholder="Select a team"
          placement="topRight"
        >
          {teams.map((team) => (
            <Option key={team._id} value={team.teamName}>
              {team.teamName}
            </Option>
          ))}
        </Select>
        <Select
          style={{ width: '60%' }}
          placeholder="Select a frequent sentence"
          disabled={!selectedTeam}
          onSelect={(value) => setUserInput(value)}
          placement="topRight"
        >
          {selectedTeam &&
            selectedTeam.frequentSentences.map((sentence, index) => (
              <Option key={index} value={sentence}>
                {sentence}
              </Option>
            ))}
        </Select>
      </div>

      <div className="flex h-[80px] items-center ">
        <Textarea
          rows="2"
          className="mx-4 ml-4 block w-full resize-none rounded-lg border-0 bg-white p-2 font-sans text-gray-900 outline-none cursor-auto"
          placeholder={userTypingPlaceholder}
          value={userInput}
          onChange={handleChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSubmit();
            }
          }}
          onBlur={() =>
            sendMessage({
              url: `${scoutChatCenterServerUrl}/chat/messageFromConsultants/${id}`,
              payload: { typing: false }
            })
          }
        />
        <button
          type="submit"
          disabled={!userInput.trim()}
          className={`${
            userInput.trim().length > 0
              ? 'cursor-pointer'
              : 'cursor-not-allowed'
          } inline-flex justify-center rounded-full border-0 bg-transparent p-2`}
          onClick={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <MdSend className="h-[24px] w-6" color="#3B464E" />
        </button>
      </div>
    </div>
  );
});
